export default __webpack_public_path__ + "static/media/pc06-1.7c83712d.png";